import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTabs,{staticClass:"tabs",attrs:{"fixed-tabs":""}},_vm._l((_vm.tabs),function(tab){return _c(VTab,{key:tab.name,attrs:{"href":tab.to,"link":!!tab.to},on:{"click":function($event){return _vm.handleClick(tab)}}},[_vm._v(_vm._s(tab.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }